import React from "react";
import {Redirect, Route} from "react-router-dom";
import {Content} from "./Content";
import { shallowEqual, useSelector } from "react-redux";
import { permissionAllow } from "../../../../app/util/Helpers";

export function ContentRoute({ children, permission, permissionType, component, render, ...props }) {

  const adminUser = useSelector( ({auth}) => (auth.user), shallowEqual);

  return (
    <Route {...props}>
      {routeProps => {

        if (permission && !permissionAllow(adminUser, permission, permissionType)){
          return <Redirect to="/overview" />
        }


        if (typeof children === "function") {
          return <Content>{children(routeProps)}</Content>;
        }

        if (!routeProps.match) {
          return null;
        }

        if (children) {
          return <Content>{children}</Content>;
        }

        if (component) {
          return (
            <Content>{React.createElement(component, routeProps)}</Content>
          );
        }

        if (render) {
          return <Content>{render(routeProps)}</Content>;
        }

        return null;
      }}
    </Route>
  );
}
